import createComponent from 'styles/fela/createComponent';
import {
  withSpinning,
} from 'styles/fela/mixins';
import PlusIcon from 'components/Icons/PlusIcon';
import CircleIcon from 'components/Icons/CircleIcon';
import { BUTTON_HEIGHT } from 'utils/constants';

export const Container = createComponent(({ theme, inProgress, short }) => ({
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  fontSize: theme.fontSize.normal,
  letterSpacing: '0.5px',
  userSelect: 'none',
  extend: [
    {
      condition: inProgress,
      style: {
        cursor: 'wait',
      },
    },
    {
      condition: short,
      style: {
        display: 'inline-block',
      },
    },
  ],
  ':hover:not([disabled]) svg circle': {
    fill: theme.color.whiteButtonBackgroundHover,
  },
  ':focus': {
    outline: 'none',
  },
  ':focus-visible': {
    boxShadow: `0 0 0 2px ${theme.color.primary}`,
    borderRadius: '50%',
  },
}), 'div', ['inProgress', 'short']);

export const IconContainer = createComponent(() => ({
  position: 'relative',
  width: BUTTON_HEIGHT,
  height: BUTTON_HEIGHT,
}));

export const StyledCircleIcon = createComponent(({ theme }) => ({
  color: 'transparent',
  width: '100%',
  height: '100%',
  overflow: 'visible',
  fill: theme.color.whiteButtonBackground,
  '& circle': {
    transition: 'fill 0.2s ease-in-out',
  },
}), CircleIcon, []);

export const StyledPlusIcon = createComponent(({ inProgress }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  color: 'white',
  width: '100%',
  height: '100%',
  overflow: 'visible',
  transform: 'rotate(45deg)',
  extend: [
    {
      condition: inProgress,
      style: withSpinning(500),
    },
  ],
}), PlusIcon, ['inProgress']);
